import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';

@Pipe({ name: 'capitilizeFirstLetter' })
export class CapitilizeFirstLetterPipe implements PipeTransform {
    /**
     * Transform
     *
     * @param {string} value
     * @returns {string}
     */
    transform(value: string): string {
        return _.capitalize(value);
    }
}
